import * as React from 'react';

export function Ok({color, width, height, onClick}: {
    color?: string,
    width?: number,
    height?: number,
    onClick: () => void,
}) {
    // https://icons.getbootstrap.com/icons/check-lg/
    return (
    <svg xmlns="http://www.w3.org/2000/svg" className="bi bi-check-lg" viewBox="0 0 16 16"
        width={width || 16} height={height || 16} fill={color || 'currentColor'}
        onClick={onClick}>
        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
    </svg>);
}

export function Cancel({color, width, height, onClick}: {
    color?: string,
    width?: number,
    height?: number,
    onClick: () => void,
}) {
    // https://icons.getbootstrap.com/icons/x-lg/
    return (
    <svg xmlns="http://www.w3.org/2000/svg" className="bi bi-x-lg" viewBox="0 0 16 16"
        width={width || 16} height={height || 16} fill={color || 'currentColor'}
        onClick={onClick}>
        <path fillRule="evenodd" d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"/>
        <path fillRule="evenodd" d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"/>
    </svg>);
}

export function Delete({color, width, height, onClick}: {
    color?: string,
    width?: number,
    height?: number,
    onClick: () => void,
}) {
    // https://icons.getbootstrap.com/icons/trash/
    return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"
        width={width || 16} height={height || 16} fill={color || 'currentColor'}
        onClick={onClick}>
        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
        <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
    </svg>);
}

export function ArrowLeft({color, width, height, onClick}: {
    color?: string,
    width?: number,
    height?: number,
    onClick: () => void,
}) {
    // https://icons.getbootstrap.com/icons/arrow-left/
    return (
    <svg xmlns="http://www.w3.org/2000/svg" className="bi bi-arrow-left" viewBox="0 0 16 16"
        width={width || 16} height={height || 16} fill={color || 'currentColor'}
        onClick={onClick}>
        <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
    </svg>);
}

export function List({color, width, height, onClick}: {
    color?: string,
    width?: number,
    height?: number,
    onClick: () => void,
}) {
    // https://icons.getbootstrap.com/icons/list/
    return (
    <svg xmlns="http://www.w3.org/2000/svg" className="bi bi-list" viewBox="0 0 16 16"
        width={width || 16} height={height || 16} fill={color || 'currentColor'}
        onClick={onClick}>
        <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
    </svg>);
}

export function Plus({color, width, height, onClick}: {
    color?: string,
    width?: number,
    height?: number,
    onClick: () => void,
}) {
    // https://icons.getbootstrap.com/icons/plus/
    return (
    <svg xmlns="http://www.w3.org/2000/svg" className="bi bi-plus" viewBox="0 0 16 16"
        width={width || 16} height={height || 16} fill={color || 'currentColor'}
        onClick={onClick}>
        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
    </svg>);
}

export function Down({color, width, height, onClick}: {
    color?: string,
    width?: number,
    height?: number,
    onClick: () => void,
}) {
    // https://icons.getbootstrap.com/icons/chevron-down/
    return (
    <svg xmlns="http://www.w3.org/2000/svg" className="bi bi-chevron-down" viewBox="0 0 16 16"
        width={width || 16} height={height || 16} fill={color || 'currentColor'}
        onClick={onClick}>
        <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
    </svg>);
}

export function Up({color, width, height, onClick}: {
    color?: string,
    width?: number,
    height?: number,
    onClick: () => void,
}) {
    // https://icons.getbootstrap.com/icons/chevron-up/
    return (
    <svg xmlns="http://www.w3.org/2000/svg" className="bi bi-chevron-up" viewBox="0 0 16 16"
        width={width || 16} height={height || 16} fill={color || 'currentColor'}
        onClick={onClick}>
        <path fillRule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>
    </svg>);
}
